"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaseEditModalButton = CaseEditModalButton;
exports.CaseAddNewModalButton = CaseAddNewModalButton;
exports.CaseAddNewInTypeFolderButton = CaseAddNewInTypeFolderButton;
exports.SubCaseAddNewModalButton = SubCaseAddNewModalButton;
exports.CaseAndSubCaseAddButtonGroup = CaseAndSubCaseAddButtonGroup;
exports.buildCaseHeaderBadge = buildCaseHeaderBadge;
exports.buildCaseBreadcrumbLabel = buildCaseBreadcrumbLabel;
exports.buildContractHeaderBadge = buildContractHeaderBadge;
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const GeneralModalButtons_1 = require("../../../View/Modals/GeneralModalButtons");
const TasksGlobalController_1 = require("../../TasksGlobalController");
const TasksGlobalModalButtons_1 = require("../TasksGlobalModalButtons");
const CaseModalBody_1 = require("./CaseModalBody");
const SubCaseModalBody_1 = require("./SubCaseModalBody");
const CaseValidationSchema_1 = require("./CaseValidationSchema");
function CaseEditModalButton({ modalProps: { onEdit, initialData }, buttonProps, }) {
    const parentCase = initialData?._parentCase;
    const headerBadge = buildCaseHeaderBadge(initialData?._parent, parentCase);
    return (react_1.default.createElement(GeneralModalButtons_1.GeneralEditModalButton, { modalProps: {
            onEdit: onEdit,
            ModalBodyComponent: CaseModalBody_1.CaseModalBody,
            modalTitle: "Edycja sprawy",
            headerBadge,
            repository: TasksGlobalController_1.casesRepository,
            initialData: initialData,
            makeValidationSchema: CaseValidationSchema_1.makeCaseValidationSchema,
        }, buttonProps: {
            ...buttonProps,
            buttonVariant: "outline-success",
        } }));
}
function CaseAddNewModalButton({ modalProps: { onAddNew, contextData }, buttonProps, }) {
    const headerBadge = buildCaseHeaderBadge(contextData);
    return (react_1.default.createElement(GeneralModalButtons_1.GeneralAddNewModalButton, { modalProps: {
            onAddNew: onAddNew,
            contextData,
            ModalBodyComponent: CaseModalBody_1.CaseModalBody,
            additionalModalBodyProps: { SpecificContractModalBody: CaseModalBody_1.CaseModalBody },
            modalTitle: "Nowa sprawa",
            headerBadge,
            repository: TasksGlobalController_1.casesRepository,
            makeValidationSchema: CaseValidationSchema_1.makeCaseValidationSchema,
        }, buttonProps: {
            buttonCaption: "Dodaj sprawę",
            buttonVariant: "outline-success",
            ...buttonProps,
        } }));
}
/** "Dodaj sprawę" na poziomie folderu typu: jak CaseAddNewModalButton, ale z typem wybranym z góry.
 *  contextData = CaseType folderu z doczepionym `_parentMilestone` (patrz buildTree w TasksGlobal.tsx). */
function CaseAddNewInTypeFolderButton({ modalProps: { onAddNew, contextData }, buttonProps, }) {
    // milestone → kontekst (_parent); caseType (bez kamienia) → wstępny wybór typu.
    const { _parentMilestone: milestone, ...caseType } = contextData ?? {};
    const headerBadge = buildCaseHeaderBadge(milestone);
    return (react_1.default.createElement(GeneralModalButtons_1.GeneralAddNewModalButton, { modalProps: {
            onAddNew,
            contextData: milestone,
            ModalBodyComponent: CaseModalBody_1.CaseModalBody,
            additionalModalBodyProps: { preselectedCaseType: caseType },
            modalTitle: "Nowa sprawa",
            headerBadge,
            repository: TasksGlobalController_1.casesRepository,
            makeValidationSchema: CaseValidationSchema_1.makeCaseValidationSchema,
        }, buttonProps: {
            buttonCaption: "Dodaj sprawę",
            buttonVariant: "outline-success",
            ...buttonProps,
        } }));
}
function SubCaseAddNewModalButton({ modalProps: { onAddNew, contextData }, buttonProps, }) {
    const parentCase = contextData;
    const headerBadge = buildCaseHeaderBadge(parentCase?._parent, parentCase);
    return (react_1.default.createElement(GeneralModalButtons_1.GeneralAddNewModalButton, { modalProps: {
            onAddNew: onAddNew,
            contextData,
            ModalBodyComponent: SubCaseModalBody_1.SubCaseModalBody,
            additionalModalBodyProps: {},
            modalTitle: "Nowa podsprawa",
            headerBadge,
            repository: TasksGlobalController_1.casesRepository,
            makeValidationSchema: CaseValidationSchema_1.makeCaseValidationSchema,
        }, buttonProps: {
            buttonCaption: "Dodaj podsprawę",
            buttonVariant: "outline-primary",
            ...buttonProps,
        } }));
}
function CaseAndSubCaseAddButtonGroup({ modalProps: { onAddNew, contextData }, buttonProps, }) {
    return (react_1.default.createElement("div", { className: "d-flex gap-2" },
        react_1.default.createElement(SubCaseAddNewModalButton, { modalProps: { onAddNew, contextData }, buttonProps: buttonProps }),
        react_1.default.createElement(TasksGlobalModalButtons_1.TaskAddNewModalButton, { modalProps: { onAddNew: onAddNew, contextData }, buttonProps: buttonProps })));
}
/** Badge z kontekstem: kontrakt | kamień milowy [| sprawa-rodzic dla podspraw] */
function buildCaseHeaderBadge(milestone, parentCase) {
    const label = buildCaseBreadcrumbLabel(milestone, parentCase);
    if (!label)
        return undefined;
    return (react_1.default.createElement(react_bootstrap_1.Badge, { bg: "secondary", text: "light", pill: true, className: "text-break", style: { whiteSpace: "normal" } }, label));
}
/** Buduje czytelną ścieżkę: kontrakt | kamień milowy [| sprawa-rodzic] */
function buildCaseBreadcrumbLabel(milestone, parentCase) {
    const contractLabel = buildContractFirstLineLabel(milestone?._contract);
    const milestoneLabel = buildMilestoneNameLabel(milestone);
    const parentCaseLabel = parentCase
        ? (parentCase.name || parentCase._type?.name || parentCase._typeFolderNumber_TypeName_Number_Name || "")
        : "";
    return [contractLabel, milestoneLabel, parentCaseLabel].filter(Boolean).join(" | ").trim();
}
/** Badge z samym kontraktem — używana gdy kamień milowy nie jest jeszcze znany */
function buildContractHeaderBadge(contract) {
    const label = buildContractFirstLineLabel(contract);
    if (!label)
        return undefined;
    return (react_1.default.createElement(react_bootstrap_1.Badge, { bg: "secondary", text: "light", pill: true, className: "text-break", style: { whiteSpace: "normal" } }, label));
}
function buildContractFirstLineLabel(contract) {
    if (!contract || typeof contract !== "object") {
        if (contract)
            console.warn("buildContractFirstLineLabel: oczekiwano obiektu kontraktu, otrzymano:", contract);
        return "";
    }
    // Pola obliczeniowe serwera — dostępne na pełnych obiektach, obsługują oba typy kontraktów
    const computed = contract._ourIdOrNumber_Alias || contract._ourIdOrNumber_Name;
    if (computed)
        return computed;
    const aliasPart = contract.alias;
    if ("ourId" in contract && contract.ourId) {
        return [contract.ourId, aliasPart].filter(Boolean).join(" | ").trim();
    }
    // OtherContract — pomiń "Brak powiązania" gdy _ourContract niedostępny
    const ourRelatedId = contract._ourContract?.ourId ?? "";
    const contractId = [`${contract._type?.name ?? ""} ${contract.number}`.trim(), ourRelatedId ? `➔ ${ourRelatedId}` : ""]
        .filter(Boolean)
        .join(" ");
    return [contractId, aliasPart].filter(Boolean).join(" | ").trim();
}
function buildMilestoneNameLabel(milestone) {
    if (!milestone)
        return "";
    const milestoneName = milestone.name || milestone._type?.name;
    return milestoneName ? String(milestoneName).trim() : "";
}
